<template>
    <div class="dashboard-section">
        <h2 class="dashboard-section__title" v-if="title && title.length">{{title}}</h2>
        <slot name="header"></slot>
        <div class="dashboard-section__children-wrap">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Section',
        props: {
            title: String,
        }
    }
</script>

<style lang="scss" scoped>
    .dashboard-section {
        max-width: $dashboard-width;
        margin: 0 auto;
        padding-left: 8px;
        padding-right: 8px;
        padding-bottom: 50px;
        display: flex;
        flex-flow: column nowrap;
        &__title {
            font-style: normal;
            font-weight: bold;
            font-size: $dashboard-font-size-heading;
            line-height: 30px;
            margin-bottom: 20px;
            padding-left: 60px;
        }
    }
</style>